import { Routes } from "@angular/router";
import { GalleryComponent } from "./gallery/gallery.component";
import { VideoDetailComponent } from "./gallery/video-detail/video-detail.component";
import { PhotoDetailComponent } from "./gallery/photo-detail/photo-detail.component";

export const routes: Routes = [
//   // { path: '', redirectTo: 'admin', pathMatch: 'full' },
//   // { path: 'admin', loadChildren: 'app/admin/pages/pages.module#PagesModule' },
    {path: '', component: GalleryComponent, pathMatch: 'full'},
    {path: 'videos/:id', component: VideoDetailComponent},
    {path: 'photos/:id', component: PhotoDetailComponent},
//   // { path: 'offers/:id/edit', component: WizardComponent, data: {action: 'edit'} },
//   // { path: 'register', loadChildren: 'app/pages/register/register.module#RegisterModule' },
    // { path: '**', redirectTo: '' }
];
//
// export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
//     preloadingStrategy: PreloadAllModules,
//    // useHash: true
// });



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/app.routing.ts